// Best-effort MIME guess from a filename extension, used by "View" so a
// decrypted file opens in the browser's own viewer instead of downloading.
//
// Deliberately excludes text/html and image/svg+xml - anything that can
// execute script as a top-level document. blob: URLs are same-origin, so
// opening an attacker-crafted decrypted file as HTML/SVG would run script
// with access to this origin's storage (wrapped private keys live in
// IndexedDB). Every type here renders inertly - image, sandboxed PDF
// viewer, or plain text - even with fully attacker-controlled bytes.
// Anything else falls back to a plain download, which is the safe default.
const EXTENSION_MIME: Record<string, string> = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  txt: "text/plain",
  json: "application/json",
};

export function guessMimeType(filename: string): string {
  const base = filename.replace(/\.enc$/i, "");
  const ext = base.split(".").pop()?.toLowerCase();
  return (ext && EXTENSION_MIME[ext]) || "application/octet-stream";
}
